import { get } from './request';
export default async function(diy) {
  if (!diy) return;
  const result = await get(`//query.aliyun.com/rest/${diy}`);
  if (result.data) {
    try {
      // 让js执行在局部作用域内
      eval(`(function(){${result.data}})();`);
    } catch (error) {
      console.warn(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/domDIY.js